// Impersonation opens the person's session in a new tab through a one-time
// code (POST /auth-impersonate answers {code, expiresAt}: 60 seconds, single
// use). The code rides in the URL fragment, which the browser never sends to
// a server or puts in a Referer; the tab redeems it and drops it from the
// address bar (view/redirect/redirect-impersonate.js). No token is ever in a
// URL.
export const impersonationUrl = (site, code) => `${site}/redirect/impersonate#${code}`

// What to show when the impersonation was refused (a nested impersonation,
// someone the caller may not impersonate) or failed.
export const impersonationError = e =>
  (e && e.data && (e.data.message || (typeof e.data.error === 'string' && e.data.error))) || "Impersonation couldn't start. Try again."
